// eslint-disable-next-line import/prefer-default-export
export function generateRandomCalculus(): string {
    const randomOperator = () => {
        const randomIndex = Math.trunc(Math.random() * 10) % 4;
        const operators = ['*', '/', '-', '+'];
        return operators[randomIndex];
    };
    const randomNumber1 = Math.trunc(Math.random() * 10);
    const randomNumber2 = Math.trunc(Math.random() * 10);
    return `${randomNumber1}${randomOperator()}${randomNumber2}`;
}

function formatIntegerPartsOnly(str) {
    return str.replace(/\d+[.,]?\d*/g, (match) => {
        const [intPart, decimalPart] = match.split(/[.,]/);
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        if (match.includes(',')) {
            return decimalPart !== undefined ? `${formattedInt},${decimalPart}` : `${formattedInt},`;
        }
        if (match.includes('.')) {
            return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : `${formattedInt}.`;
        }

        return formattedInt;
    });
}

export function formatCalculusForStudent(calculus: string): string {
    return formatIntegerPartsOnly(calculus)
        .replace('*', ' x ')
        .replace('/', ' : ')
        .replace('-', ' - ')
        .replace('+', ' + ')
        .replace('=', ' = ');
}
